import { createReducer } from '@reduxjs/toolkit';

import { setIsLoading, setProductsList, setTotalCount } from './productsActions.js';

const initialState = {
  productsList: [],
  totalCount: 0,
  isLoading: false,
};

const products = createReducer(initialState, (builder) => {
  builder
    .addCase(setProductsList, (state, { payload: productsList }) => ({ ...state, productsList }))
    .addCase(setTotalCount, (state, { payload: totalCount }) => ({ ...state, totalCount }))
    .addCase(setIsLoading, (state, { payload: isLoading }) => ({ ...state, isLoading }));
});

export default products;
